// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + {"66":"zh-translations","852":"th-translations","866":"en-PSEUDO-translations","877":"id-translations","943":"en-translations"}[chunkId] + "-" + {"66":"92f228dff6f5e2ce60de","852":"a09e1be5abd67d89d939","866":"2595b608e484d7317b47","877":"356693db77066e73f6b1","943":"40de9ad3bbd0ffdd4697"}[chunkId] + ".js";
};